import React, { useState } from "react";
import { useLocation, Link, useHistory } from "react-router-dom";
import PopularTagsContainer from "./Components/Containers/PopularTagsContainer";
import RandomSleeveContainer from "./Components/Containers/RandomSleeveContainer";
import SleeveMini from "./Components/SleeveMini";
import { useUser } from "@dreamchimney/user-context";

const RightNav = (props) => {
  let history = useHistory();
  const { state: userState, dispatch } = useUser();

  const location = useLocation();
  const [pathName, setPathName] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  React.useEffect(() => {
    setPathName(location.pathname);
  }, [location]);

  const handleChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    history.push(`/search?page=1&find=${searchTerm}`);
  };

  return (
    <div>
      {userState.loggedin && userState.isChim && (
        <div className="add-sleeve">
          <div>
            <Link to={`/sleeve/add`}>Add Sleeve</Link>
          </div>
        </div>
      )}

      {userState.loggedin && (
        <React.Fragment>
          <h4>
            {userState.user.full_name} {userState.isChim && ` Chimney`}
          </h4>
          {userState.isChim && (
            <div>
              <Link to={`/sleeves/by/${userState.user.dir}`}>My Sleeves</Link>
            </div>
          )}
          {userState.loggedin && userState.user && (
            <div>
              <Link to={`/sleeves/favorites/${userState.user.dir}`}>My Favorites</Link>
            </div>
          )}
          <hr />
        </React.Fragment>
      )}

      <div className="right-nav-box">
        <ul className="list-unstyled">
          <li>
            <Link to={`/sleeves/list`}>Browse all Sleeves</Link>
          </li>
          <li>
            <Link to={`/about`}>About this site</Link>
          </li>
          <li className="nav-search">
            <h4>Search Sleevery</h4>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="find"
                id="find"
                className="form-control find"
                autoComplete="off"
                placeholder=""
                required
                value={searchTerm}
                onChange={handleChange}
              />
              <button type="submit" className="submit">
                Search
              </button>
            </form>
          </li>
        </ul>

        <h4>Popular Sleeves</h4>
        <ul className="list-unstyled">
          <li>
            <Link to={`/sleeves/popular`}>Most Favorites</Link>
          </li>
          <li>
            <Link to={`/sleeves/comments`}>Most Comments</Link>
          </li>
        </ul>

        <hr />
        <h4>Random Sleeve</h4>
        <RandomSleeveContainer
          pathName={pathName}
          render={({ sleeve }) => {
            return (
              <div>
                <SleeveMini sleeve={sleeve} />
                <div style={{ textAlign: "center", fontSize: "13px", marginTop: "4px" }}>
                  "
                  <Link to={`/sleeves/view/${sleeve.id}`} title={sleeve.title}>
                    {sleeve.title}
                  </Link>
                  " by {sleeve.artist}
                </div>
              </div>
            );
          }}
        />
        <hr />
        <h4>Popular Tags</h4>
        <PopularTagsContainer
          render={({ tags }) => {
            return (
              <ul className="list-unstyled tags-popular">
                {Object.keys(tags).map((tag, i) => {
                  return (
                    <li key={`tag-${i}`}>
                      <Link to={`/tag/${tag}`}>{tag}</Link> ({tags[tag]})
                    </li>
                  );
                })}
              </ul>
            );
          }}
        />
      </div>
    </div>
  );
};

export default RightNav;
